'use client';

import { useTheme } from 'next-themes';
import { IconBrightness } from '@tabler/icons-react';

import { Button } from '../ui/button';

export function ModeToggle() {
  const { theme, setTheme } = useTheme();

  const handleToggleThemeMode = () => {
    let newTheme = theme;

    if (theme === 'dark') {
      newTheme = 'light';
    } else if (theme === 'light') {
      newTheme = 'dark';
    } else {
      newTheme = 'system';
    }

    setTheme(newTheme);
  };

  return (
    <Button
      className="group/toggle size-8"
      onClick={handleToggleThemeMode}
      size="icon"
      variant="secondary"
    >
      <IconBrightness />
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}
